import { useContext, useEffect, useState } from 'react'
import { Select } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import styles from './ApproveVoterForm.module.scss'

export const ApproveVoterForm = ({ confirm, matches, loading }) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const [ineligibleApprove, setInelegibleApprove] = useState(false)
  const [options, setOptions] = useState([])

  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const formik = useFormik({
    initialValues: { electorId: 'newregistrant' },
    validationSchema: Yup.object({ electorId: Yup.string().required(t('admin.onlineRegistration.validations.electorId')) }),
    onSubmit: (values) => confirm(values.electorId),
  })

  useEffect(() => {
    setHeaderLabel(t('admin.onlineRegistration.approveVoter'))
    const buttons = [
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('buttons.approve'), onClick: formik.handleSubmit },
    ]
    if (ineligibleApprove) {
      setBtns({ text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' })
    } else {
      setBtns(buttons)
    }
    if (loading) {
      setBtns([])
    }
  }, [ineligibleApprove, loading])

  useEffect(() => {
    const electorIds = matches?.map((e) => {
      return { value: e.electorId, label: e.electorId }
    })
    if (electorIds?.length === 1) {
      formik.setFieldValue('electorId', electorIds[0].value)
    } else if (electorIds?.length > 1) {
      formik.setFieldValue('electorId', '')
      setOptions(electorIds)
    }
  }, [matches, currentLanguage])

  if (options.length) {
    return (
      <Select
        label={t('admin.onlineRegistration.selectElectorIdToApprove')}
        formik={formik}
        actions
        options={options}
        field='electorId'
        value={formik.values.electorId}
        isRequired={true}
      />
    )
  }
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        {' '}
        {formik.values.electorId === 'error'
          ? t('admin.onlineRegistration.ineligibleApproveElector')
          : formik.values.electorId === 'newregistrant'
          ? t('admin.onlineRegistration.approveNewRegistrant')
          : t('admin.onlineRegistration.approveMergeElector')}
      </div>

      <div className={styles['section']}></div>
    </div>
  )
}
